import { company } from '~/company/Company';

export const PHONE_INPUT_NODE_ID = 'auth-phone-input-v3';
export const PHONE_INPUT_PLACEHOLDER = company.config.phonePlaceholder || '+';
